<script>

export default {
    props: {
        'title': String,
        'value': Object,
        'success': Function,
        'room': Object,
        'stuff': Object,
    },
    data() {
        return {
            data: {},
            is_static: 1,
        };
    },
    computed: {
        isStatic() {
            return this.$store ? this.$store.state.notification : null;
        },
    },
    mounted() {
        var vm = this;

        vm.newData();
        vm.load();
    },
    methods: {
        load() {
            var vm = this;

            if (vm.value) {
                vm.data = Object.assign({}, vm.value);
            } else {
                if (vm.room.id)
                    vm.data.room_id = vm.room.id;

                if (vm.stuff.id)
                    vm.data = Object.assign({}, vm.stuff);
            }
        },
        newData() {
            var vm = this;

            var data = {
                id: null,
                ref_no: null,
                ref_no_external: null,
                room_id: null,
                stuff_type_id: null,
                x: null,
                y: null,
                number: null,
                qty: null,
                layer: null,
                rotation: 0,
            };

            vm.data = Object.assign({}, data);
        },
        async submit() {
            var vm = this;
            vm.$loading.on('room_detail_stuff_submit');

            try {
                var postData = vm._createPostData(vm.data);
                var resp = await this.$api.Stuff.create(postData);

                var data = resp.data;

                vm.$flash.success(data.message);

                vm.success(vm.data);
                vm.$sidebar.hide();
            } catch (err) {
                vm.$flash.error(err.response.data.message);
            }
            vm.$loading.off('room_detail_stuff_submit');
        },
        _createPostData: function (data) {
            var vm = this;

            data.room_id = vm.room.id;

            return data;
        },
        onChangeType(val, oldVal, model) {
            var vm = this;

            vm.is_static = model.is_static;
        },
        fetchStuffType: async function (params) {
            var newParams = {
                ...params,
                page: 'all'
            }
            const resp = await this.$api.StuffType.all(newParams)

            const data = resp.data.data

            const list = data.map(row => ({
                id: row.id,
                text: row.text,
                model: row,
            }))

            const meta = resp.data.meta

            return {
                options: list,
                more: meta.current_page < meta.last_page
            }
        },
        fetchRoom: async function (params) {
            const resp = await this.$api.Room.all(params)

            const data = resp.data.data

            const list = data.map(row => ({
                id: row.id,
                text: row.text,
                model: row,
            }))

            const meta = resp.data.meta

            return {
                options: list,
                more: meta.current_page < meta.last_page
            }
        },
    }
}
</script>

<template>
    <b-form @submit="submit">
        <simplebar class="h-25 sidebar-simplebar">
            <div class="p-4">
                <BRow class="gy-3">
                    <BCol lg="12" v-if="$ac.hasAccess('stuff_full_access')">
                        <label class="form-label" for="product-title-input">{{ $t('stuff.label.ref_no')
                        }}</label>
                        <input type="text" class="form-control" v-model="data.ref_no" id="product-title-input"
                            :placeholder="$t('stuff.placeholder.ref_no')" />
                    </BCol>
                    <BCol lg="12">
                        <label class="form-label" for="product-title-input">{{ $t('stuff.label.number')
                        }}</label>
                        <input type="number" class="form-control" v-model="data.number" step="1"
                            id="product-title-input" :placeholder="$t('stuff.placeholder.number')" :disabled="true" />
                    </BCol>
                    <BCol lg="12" v-if="$ac.hasAccess('stuff_full_access')">
                        <label for="choices-publish-status-input" class="form-label">{{
                            $t('stuff.label.room') }}</label>
                        <dynamic-select v-model="data.room_id" :placeholder="$t('stuff.placeholder.room')"
                            :loadOptions="fetchRoom" />
                    </BCol>
                    <BCol lg="12">
                        <label for="choices-publish-status-input" class="form-label">{{
                            $t('stuff.label.stuff_type') }}</label>
                        <dynamic-select v-model="data.stuff_type_id" :onChange="onChangeType"
                            :placeholder="$t('stuff.placeholder.stuff_type')" :loadOptions="fetchStuffType" />
                    </BCol>
                    <BCol lg="12" v-if="is_static == 0 && data.stuff_type_id">
                        <label class="form-label" for="product-title-input">{{
                            $t('stuff.label.ref_no_external') }}</label>
                        <input type="text" class="form-control" v-model="data.ref_no_external" id="product-title-input"
                            :placeholder="$t('stuff.placeholder.ref_no_external')" />
                    </BCol>
                    <BCol lg="12" v-if="is_static == 0 && data.stuff_type_id">
                        <label class="form-label" for="product-title-input">{{
                            $t('stuff.label.qty') }}</label>
                        <div class="input-group">
                            <input type="number" step="1" class="form-control" v-model="data.qty"
                                id="product-title-input" :placeholder="$t('stuff.placeholder.qty')" />
                            <span class="input-group-text" id="basic-addon2">{{ $t('basic.label.person')
                            }}</span>
                        </div>
                    </BCol>
                    <BCol lg="12" v-if="$ac.hasAccess('stuff_full_access')">
                        <label class="form-label" for="product-title-input">{{ $t('stuff.label.x')
                        }}</label>
                        <input type="number" class="form-control" v-model="data.x" id="product-title-input" step="1"
                            :placeholder="$t('stuff.placeholder.x')" />
                    </BCol>
                    <BCol lg="12" v-if="$ac.hasAccess('stuff_full_access')">
                        <label class="form-label" for="product-title-input">{{ $t('stuff.label.y')
                        }}</label>
                        <input type="number" class="form-control" v-model="data.y" id="product-title-input"
                            :placeholder="$t('stuff.placeholder.y')" step="1" />
                    </BCol>
                    <BCol lg="12" v-if="$ac.hasAccess('stuff_full_access')">
                        <label class="form-label" for="product-title-input">{{ $t('stuff.label.rotate')
                        }}</label>
                        <input type="number" class="form-control" v-model="data.rotation" id="product-title-input"
                            :placeholder="$t('stuff.placeholder.rotate')" step="1" max="360" />
                    </BCol>
                    <BCol lg="12" class="mt-5" v-if="($ac.hasAccess('stuff_full_access') || ($ac.hasAccess('stuff_create') && $ac.hasAccessStore(room.store_id)))">
                        <BRow>
                            <BCol cols="6">
                                <BButton type="button" variant="light" class="w-100" id="reset-layout"
                                    @click="$sidebar.hide()">
                                    <i class="mdi mdi-arrow-left align-bottom me-1"></i>
                                    {{ $t('basic.btn.cancel') }}
                                </BButton>
                            </BCol>
                            <BCol cols="6">
                                <BButton type="submit" variant="success" class="w-100" @click="submit"
                                    :disabled="$loading.get('room_detail_stuff_submit')">
                                    <loading :loading="$loading.get('room_detail_stuff_submit')">
                                        <i class="mdi mdi-floppy me-1"></i>
                                        {{ $t('basic.btn.save') }}
                                    </loading>
                                </BButton>
                            </BCol>
                        </BRow>
                    </BCol>
                </BRow>
            </div>
        </simplebar>
    </b-form>
</template>